export const BI_CRM_HOME_SRC = 5;
export const BI_CRM_HOME_USERS_END_POINT = 'dash';
export const biEventIds = {
  CARD_BUTTON_CLICKED: 354,
  CREATE_NEW_BUTTON_CLICKED: 489,
  CREATE_NEW_OPTION_CLICKED: 490,
  SECONDARY_BUTTON_CLICKED: 491,
  CAROUSEL_CLICKED: 492,
  FINANCES_CARD_CLICKED: 493,
  TOOL_CLICKED: 494,
  SEND_MESSAGE_TO: 745,
  SEND_MESSAGE: 748,
  VIEW_CONTACT: 819,
  IMPORT_CONTACTS: 821,
  GO_TO_WORKFLOWS: 844,
  START_FROM_SCRATCH: 853,
  USE_TEMPLATE: 852,
  VIEW_ALL_COMUNNICATIONS: 854,
  CONNECT_TO_COMUNNICATIONS: 855,
  VIEW_ALL_MARKETING: 860,
  CONNECT_TO_MARKETING: 1114,
  VIEW_ALL_FINANCE: 1115,
  CONNECT_TO_FINANCE: 1116,
  GO_TO_MARKETING: 1122,
  SCROLL_DOWN: 1300,
  CRM_HOME_VIDEO: 1314,
};
